import React from "react";
import FilterRow from "./FilterRow";
import {FaFont, FaHeading, FaAlignLeft, FaExternalLinkAlt} from "react-icons/fa";

export const RecommendationsFilter = ({handleSwitchToggle, state}) => {
    const t = state.toggles;
    return (
        <FilterRow
            label="Recommendation differs"
            items={[
                {label: "Title", icon: FaFont, color: "#0d6efd", checked: t.titleChecked, onChange: handleSwitchToggle("titleChecked"), key: "title"},
                {label: "H1", icon: FaHeading, color: "#0d6efd", checked: t.h1Checked, onChange: handleSwitchToggle("h1Checked"), key: "h1"},
                {label: "Meta description", icon: FaAlignLeft, color: "#0d6efd", checked: t.metaChecked, onChange: handleSwitchToggle("metaChecked"), key: "meta"},
                {label: "Redirect", icon: FaExternalLinkAlt, color: "#0d6efd", checked: t.redirectChecked, onChange: handleSwitchToggle("redirectChecked"), key: "redirect"}
            ]}
        />
    );
};
